import React from 'react';
import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo';

const Recruitments = () => {
  const { t } = useTranslation('navbar');
  const title = `Betonoki - ${t('recruitments', { defaultValue: 'Recruitments' })}`;
  const description = 'Rekrutacja w Betonoki. Aktualne informacje i możliwości współpracy.';
  return (
    <>
      <Seo title={title} description={description} path="/recruitments" />
      <Container>
        <Typography variant="h1" gutterBottom>
          Recruitments
        </Typography>
        <Typography>Recruitments</Typography>
      </Container>
    </>
  );
};

export default Recruitments;
